import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["days", "hours", "minutes", "seconds"];
  static values = { timestamp: Number };

  connect() {
    this.update();
    this.interval = setInterval(() => {
      this.update();
    }, 1000);
  }

  disconnect() {
    clearInterval(this.interval);
  }

  update() {
    const now = Math.floor(Date.now() / 1000);
    const targetTime = this.timestampValue;
    let timeRemaining = targetTime - now;
    
    // If the countdown is over
    if (timeRemaining <= 0) {
      this.daysTarget.textContent = "0";
      this.hoursTarget.textContent = "0";
      this.minutesTarget.textContent = "0";
      this.secondsTarget.textContent = "0";
      clearInterval(this.interval);
      return;
    }
    
    // Calculate time units
    const days = Math.floor(timeRemaining / 86400);
    timeRemaining %= 86400;
    
    const hours = Math.floor(timeRemaining / 3600);
    timeRemaining %= 3600;
    
    const minutes = Math.floor(timeRemaining / 60);
    const seconds = timeRemaining % 60;
    
    // Update the HTML DOM
    this.daysTarget.textContent = days;
    this.hoursTarget.textContent = hours < 10 ? `0${hours}` : hours;
    this.minutesTarget.textContent = minutes < 10 ? `0${minutes}` : minutes;
    this.secondsTarget.textContent = seconds < 10 ? `0${seconds}` : seconds;
  }
}
